$(function () {
  slider_height();
});
$(window).on('load resize', function(){
  slider_height();
});

function slider_height() {
  var widimage = window.innerWidth;
  //if( widimage < 1221 && widimage > 599 ){
  if( widimage < 1024 && widimage > 719 ){
  	$('#shopify-section-template--15527731429544__dynamic_slideshow .slideshow-slide img.slideshow-slide__image--mobile').css('display','none');
    $('#shopify-section-template--15527731429544__dynamic_slideshow .slideshow-slide img.slideshow-slide__image--desktop').css('display','');
  } else if( widimage < 720 ){
  	$('#shopify-section-template--15527731429544__dynamic_slideshow .slideshow-slide img.slideshow-slide__image--mobile').css('display','');
    $('#shopify-section-template--15527731429544__dynamic_slideshow .slideshow-slide img.slideshow-slide__image--desktop').css('display','none');
  } else {
  	$('#shopify-section-template--15527731429544__dynamic_slideshow .slideshow-slide img.slideshow-slide__image--mobile').css('display','none');
    $('#shopify-section-template--15527731429544__dynamic_slideshow .slideshow-slide img.slideshow-slide__image--desktop').css('display','');
  }
}